import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Dot.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: m }));
t.displayName = "DotIcon";
const n = t;
export {
  n as Dot,
  t as DotIcon
};
